import { INVESTOR_DATA, INVESTOR_SET_ERROR, INVESTOR_HIDE_ERROR, INVESTOR_START_LOADER, INVESTOR_STOP_LOADER, } from "./../../interfaces/Home/iInvestor";
const initialState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const investor = (state = initialState, action) => {
    switch (action.type) {
        case INVESTOR_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case INVESTOR_SET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case INVESTOR_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case INVESTOR_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case INVESTOR_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default investor;
